import { Subtask } from '@/api/pathways/subtasks/types'
import { Communication } from '@/legacy/types/communications/communications'
import { Patient } from '@/legacy/types/patients/patients'

// TYPES --------------------
export type Stack = {
  stackId: string
  patient: Patient
  patientId: string
  communicationId?: string
}

export type StackData = {
  scheduled_call?: Communication
  subtasks?: Subtask[]
}

export type SubtaskStaffStats = {
  staffId: string
  subtaskCount: number
  memberCount: number
  carePodCount: number
}

// ENUMS --------------------

export enum VisibleSubtaskStatus {
  OPEN_UNASSIGNED = 'OPEN_UNASSIGNED',
  OPEN_ASSIGNED = 'OPEN_ASSIGNED',
  IN_PROGRESS = 'IN_PROGRESS',
  ON_HOLD = 'ON_HOLD',
  COMPLETED = 'COMPLETED',
  CLOSED_IN_ERROR = 'CLOSED_IN_ERROR',
  BLOCKED = 'BLOCKED',
}

// CONST --------------------
export const queueSortBy = [
  'is_urgent,asc',
  'dueDatetime,asc',
  'priority,asc',
  'acuityScore,desc',
]
